module.exports = __webpack_public_path__ + "static/media/1.6ece61d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.mp3
// module id = B3VH
// module chunks = 1